'use client';

import { c as _c } from "react/compiler-runtime";
import { TEST_IDS } from '@repo/sdk/constants';
import { Button } from '@repo/ui/components';
import { Clock } from '@repo/ui/icons';
import { useImpersonation } from '@/app/@protected/_hooks/use-impersonation.ts';
const formatRemainingSeconds = (seconds: number): string => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
};
export const ImpersonationBanner = () => {
  const $ = _c(15);
  const {
    isImpersonating,
    remainingSeconds,
    stopImpersonation,
    stopPending,
    targetLabel,
    user
  } = useImpersonation();
  if (!isImpersonating) {
    return null;
  }
  const userLabel = targetLabel ?? user?.name ?? user?.email ?? "another user";
  let t0;
  if ($[0] !== userLabel) {
    t0 = <span className="font-medium">You are impersonating {userLabel}.</span>;
    $[0] = userLabel;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== remainingSeconds) {
    t1 = remainingSeconds !== null && remainingSeconds > 0 && <span className="inline-flex items-center gap-1 rounded bg-amber-600 px-2 py-0.5 text-xs"><Clock className="size-3" />{formatRemainingSeconds(remainingSeconds)}</span>;
    $[2] = remainingSeconds;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <div className="flex items-center gap-3">{t0}{t1}</div>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== stopImpersonation) {
    t3 = () => stopImpersonation();
    $[7] = stopImpersonation;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== stopPending || $[10] !== t3) {
    t4 = <Button className="h-auto bg-white px-3 py-1 text-amber-700 hover:bg-white/90" disabled={stopPending} onClick={t3} size="sm" variant="secondary" data-sentry-element="Button" data-sentry-source-file="impersonation-banner.tsx">Exit impersonation</Button>;
    $[9] = stopPending;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t2 || $[13] !== t4) {
    t5 = <div className="bg-amber-500 px-4 py-2 text-sm text-white" data-testid={TEST_IDS.user.impersonationBanner} data-sentry-component="ImpersonationBanner" data-sentry-source-file="impersonation-banner.tsx"><div className="flex items-center justify-between gap-4">{t2}{t4}</div></div>;
    $[12] = t2;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};